import { fetchAuthSession } from "aws-amplify/auth";
import amplifyOutputs from "@/amplify_outputs.json";

const LOGIN_HISTORY_FUNCTION_URL = amplifyOutputs.custom?.loginHistoryFunctionUrl || "";

const ERROR_MESSAGES = {
  NotAuthorizedException: "Wrong password or username",
  UserNotFoundException: "User not found",
  CodeMismatchException: "Incorrect MFA code",
  ExpiredCodeException: "MFA code expired",
  TooManyRequestsException: "Too many attempts",
  UserNotConfirmedException: "Account not confirmed",
  PasswordResetRequiredException: "Password reset required",
};

export const logFailedLogin = async (userEmail, error) => {
  if (!LOGIN_HISTORY_FUNCTION_URL || !userEmail) return;
  try {
    await fetch(LOGIN_HISTORY_FUNCTION_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        action: "LOG_FAILED_LOGIN",
        userEmail,
        errorCode: error?.name || "UnknownError",
        errorMessage: ERROR_MESSAGES[error?.name] || error?.message || "Unknown error",
      }),
    });
  } catch (err) {
    // Silently fail — login history is non-critical
    console.warn("logFailedLogin: failed to record attempt", err);
  }
};

export const getLoginHistory = async (startDate, endDate, userEmail = null) => {
  const session = await fetchAuthSession();
  const accessToken = session.tokens.accessToken.toString();

  const body = { action: "GET_LOGIN_HISTORY", startDate, endDate };
  if (userEmail) body.userEmail = userEmail;

  const response = await fetch(LOGIN_HISTORY_FUNCTION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(body),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to fetch login history");
  return data.records;
};
